"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const scrollTo_1 = __importDefault(require("./lib/scrollTo"));
const anchors = document.querySelectorAll(".anchor_columns-block");
window.addEventListener("scroll", function () {
    if (anchors) {
        anchors.forEach(setHighlight);
    }
});
anchors.forEach(setListeners);
//On scroll this sets the highlight based on the scroll position of the content.
function setHighlight(stickyDiv) {
    const nonSticky = stickyDiv.querySelectorAll(".anchor-columns-content");
    const first = nonSticky[0];
    const last = nonSticky[nonSticky.length - 1];
    const heading = stickyDiv.querySelector("h2");
    const offset = heading !== null ? heading.offsetHeight + 250 : 100;
    var highlighted = false;
    if (nonSticky.length > 0) {
        const parentElement = nonSticky[0].parentElement;
        if (parentElement) {
            parentElement.style.paddingTop = `${offset - 250}px`;
        }
    }
    const top = stickyDiv.getBoundingClientRect().top;
    nonSticky.forEach(function (item) {
        const id = item.getAttribute("id");
        const correspondingStickyItem = stickyDiv.querySelector(`a[href="${id}"]`);
        if (correspondingStickyItem) {
            const rect = item.getBoundingClientRect();
            if (rect.top <= offset && rect.bottom >= offset) {
                correspondingStickyItem.classList.add("highlight");
                highlighted = true;
            }
            else {
                correspondingStickyItem.classList.remove("highlight");
            }
        }
    });
    if (!highlighted && first && top > 0) {
        const id = first.getAttribute("id");
        const correspondingStickyItem = stickyDiv.querySelector(`a[href="${id}"]`);
        if (correspondingStickyItem) {
            correspondingStickyItem.classList.add("highlight");
        }
    }
    if (!highlighted && first && top < 0) {
        const id = last.getAttribute("id");
        const correspondingStickyItem = stickyDiv.querySelector(`a[href="${id}"]`);
        if (correspondingStickyItem) {
            correspondingStickyItem.classList.add("highlight");
        }
    }
}
//sets click listeners to allow smooth scrolling with an offset
function setListeners(stickyDiv) {
    stickyDiv.addEventListener("click", function (event) {
        if (event.target && event.target.classList.contains("anchor-columns-anchor")) {
            // Handle the click event on the items with class 'anchor-columns-anchor'
            const clickedItem = event.target;
            const href = clickedItem.getAttribute("href");
            const heading = stickyDiv.querySelector("h2");
            const offset = heading !== null ? heading.offsetHeight : 0;
            if (href) {
                const targetElement = document.getElementById(href);
                if (targetElement) {
                    (0, scrollTo_1.default)(targetElement, -offset);
                }
            }
        }
    });
}
